import type {
	ImportUploadCompleteResponse,
	ImportUploadInstructions,
	ImportUploadStartRequest,
	ImportUploadStartResponse,
} from '@today/types'
import { apiClient } from './api.client'

/** File uploads through the `web` transport (TO-392): start → PUT the bytes → complete. */
export const importUploadService = {
	/** `POST /imports` — an import execution and its presigned `PUT`. */
	async start(body: ImportUploadStartRequest): Promise<ImportUploadStartResponse> {
		const { data } = await apiClient.post<ImportUploadStartResponse>('/imports', body)
		return data
	},

	/**
	 * Sends the bytes straight to storage with the returned headers — never
	 * through `apiClient`, so no session token or cookie leaves for the bucket.
	 */
	async putBytes(upload: ImportUploadInstructions, file: Blob): Promise<void> {
		const response = await fetch(upload.url, {
			method: upload.method,
			headers: upload.headers,
			body: file,
			credentials: 'omit',
		})
		if (!response.ok) throw new Error(`The upload was refused by storage (${response.status})`)
	},

	/** `POST /imports/{id}/complete` — record the receipt. */
	async complete(importId: string): Promise<ImportUploadCompleteResponse> {
		const { data } = await apiClient.post<ImportUploadCompleteResponse>(
			`/imports/${encodeURIComponent(importId)}/complete`,
		)
		return data
	},
}
